var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Control } from 'react-redux-form';

const mapProps = {
  className: ({ fieldValue }) => {
    const _fieldValue = fieldValue.$form || fieldValue;
    return _fieldValue.submitFailed && !_fieldValue.valid ? 'has-error' : '';
  }
};

function controlComponent(className) {
  // eslint-disable-next-line react/prop-types
  return (props) => /*#__PURE__*/_jsx("div", { className: `${className} ${props.className}` }, void 0, props.children);
}

export class FormGroup extends Component {
  render() {
    if (this.props.model) {
      const className = `form-group ${this.props.className || ''}`;
      return /*#__PURE__*/(
        _jsx(Control.custom, {
          model: this.props.model,
          component: controlComponent(className),
          mapProps: mapProps }, void 0,

        this.props.children
        ));

    }

    return /*#__PURE__*/_jsx("div", { className: `form-group ${this.props.className}` }, void 0, this.props.children);
  }
}



FormGroup.defaultProps = {
  hasError: false,
  className: '',
  model: '',
  children: PropTypes.any
};








export default connect()(FormGroup);